import React from 'react'
import * as classes from './social-links.module.scss'

export const SocialLinks = () => {
  return (
    <div className={classes.socialLinks}>
      <ul>
        <li>
          <a href='https://www.linkedin.com/company/btwo-content-factory/about/'>
            IN
          </a>
        </li>
        <li>
          <a href='https://www.youtube.com/channel/UC3rALxLYfe4FsxL_NQONzsA?view_as=subscriber'>
            YT
          </a>
        </li>
      </ul>
    </div>
  )
}
